import './PostProduction.scss'
import type { ReactNode } from 'react'
import { Clients } from '#src/components/Clients.js'
import { Grid } from '#src/components/Grid.js'
import { ServicesInfoBlock } from '#src/components/ServicesInfoBlock.js'
import { StructuredData } from '#src/components/StructuredData.js'
import type { ServicePageData } from '#src/data/data.js'
import { useIsChildRoute } from '#src/hooks/useIsChildRoute.js'
import { ServicesIntro } from '#src/pages/services/ServicesIntro.js'

interface PostProductionProps {
  data: ServicePageData
  clients: string[]
  children?: ReactNode
}

export function PostProduction(props: PostProductionProps): ReactNode {
  const { grid, serviceInfo, structuredData } = props.data
  const popupIsOpen = useIsChildRoute('/services/post-production')

  return (
    <>
      <ServicesIntro
        aria-hidden={popupIsOpen}
        description={props.data.heading}
        image={props.data.heroImage.responsiveImage}
      />

      <section className="services__selected-work">
        {grid && <Grid grid={grid} galleryPath="/services/post-production/" />}
      </section>

      {serviceInfo && <ServicesInfoBlock serviceInfo={serviceInfo} />}

      <Clients clients={props.clients} />

      {props.children}

      {structuredData && <StructuredData data={structuredData} />}
    </>
  )
}
